export const categories = [
  { id: "baozhao", name: "暴躁时刻", slug: "baozhao", description: "暴躁少女最经典的发飙瞬间，每一帧都是表情包素材" },
  { id: "jingcai", name: "精彩操作", slug: "jingcai", description: "高光操作合集，展现CSGO顶尖枪法与意识" },
  { id: "gaoxiao", name: "搞笑集锦", slug: "gaoxiao", description: "让人笑到停不下来的CSGO欢乐时刻" },
  { id: "xinshou", name: "新手教学", slug: "xinshou", description: "从零开始的CSGO之路，手把手教你变强" },
  { id: "zixun", name: "资讯速递", slug: "zixun", description: "CSGO最新赛事、更新与社区动态" },
];

export const articles = [
  {
    id: 1,
    title: "暴躁少女CSGO排位连跪实录：键盘都差点被砸了",
    slug: "baozhao-shaonv-paiwei-liankui",
    category: "baozhao",
    categoryName: "暴躁时刻",
    excerpt: "本期视频记录了暴躁少女在CSGO天梯排位中遭遇连跪的经典场面，从愤怒咆哮到摔键盘的全过程，笑点密集不容错过。",
    content: `在CSGO的天梯排位中，连跪是每个玩家都经历过的噩梦。但对于以"暴躁"著称的这位B站UP主来说，连跪不仅仅是掉分那么简单——那是一场情绪火山的大爆发。

本期视频一开始，暴躁少女就以一句"今天手感特别好"立下了经典的flag。前两局确实打得不错，AK压枪精准，AWP甩狙干脆利落。但从第三局开始，局势急转直下。

先是遇到了一个全程挂机的队友，四打五的局面让少女直接破防："你是来挂机刷抖音的吗？"紧接着又是一局，对面五个小号炸鱼，各种匪夷所思的预瞄和穿墙击杀，让少女怀疑人生。

最经典的一幕发生在倒数第二局。少女在dust2的A点守包，明明听到了B点的脚步声，队友却坚持说没人。结果被对手从背后刀杀，少女直接站起来拍桌子："你耳朵是装饰品吗？"键盘都被拍得弹了起来。

整期视频笑点密集，弹幕刷屏"血压上来了"、"经典连跪套餐"。如果你也因为CSGO排位而暴躁过，这期视频绝对能让你找到共鸣。`,
    image: "https://readdy.ai/api/search-image?query=A%20young%20female%20gamer%20with%20frustrated%20expression%20playing%20CSGO%20at%20desk%20with%20gaming%20keyboard%20and%20headset%2C%20warm%20gaming%20room%20lighting%2C%20dramatic%20moment%2C%20clean%20background%20with%20gaming%20setup%2C%20high%20quality%20photography&width=800&height=450&seq=article-1&orientation=landscape",
    date: "2026-07-20",
    author: "暴躁少女",
    tags: ["排位", "连跪", "dust2", "天梯"],
    views: 128000,
    likes: 9500,
  },
  {
    id: 2,
    title: "暴躁少女CSGO五杀Ace集锦：谁说女生不能Carry全场",
    slug: "baozhao-shaonv-wusha-ace",
    category: "jingcai",
    categoryName: "精彩操作",
    excerpt: "谁说女生玩不好CSGO？暴躁少女用实力证明自己，本期精选十个五杀Ace高光时刻，每一帧都是教科书级别的操作。",
    content: `"女生不适合玩FPS游戏"——这是暴躁少女最讨厌听到的一句话。本期视频，她用十个实打实的五杀Ace来回应所有质疑。

第一个五杀发生在inferno的B点。少女手持AK47，从香蕉道单人突破，先是秒掉了守点的CT，紧接着转身预判击杀回防的敌人，最后在包点完成了一波漂亮的扫射转移。整个过程行云流水，弹幕瞬间被"666"刷屏。

第三个五杀堪称本期最佳。在mirage的A点，少女作为CT方只剩自己一人，面对敌方五人rush A的绝境。她冷静地利用烟雾弹和闪光弹拖延时间，配合精准的USP爆头，竟然完成了一打五的翻盘。连对手都在公屏打字："respect"。

除了枪法，少女的道具使用也令人印象深刻。在nuke的五杀中，她精确的烟雾封住了外场视野，两颗手雷直接将敌方血量压低，随后用M4A1-S逐个点名，完全展现了一个高水平玩家应有的游戏理解。

这期视频在B站收获了超过50万的播放量，评论区清一色都是"服了"、"这才是真正的女玩家"、"暴躁的时候是真暴躁，秀的时候是真秀"。如果你还在质疑女生的CSGO水平，看完这期视频，你会改变想法的。`,
    image: "https://readdy.ai/api/search-image?query=Professional%20female%20esports%20gamer%20celebrating%20victory%20with%20headset%20and%20gaming%20gear%2C%20RGB%20lighting%20in%20background%2C%20intense%20concentration%20on%20face%2C%20gaming%20setup%20with%20monitor%20showing%20CSGO%20scoreboard%2C%20dynamic%20action%20shot&width=800&height=450&seq=article-2&orientation=landscape",
    date: "2026-07-18",
    author: "暴躁少女",
    tags: ["五杀", "Ace", "高光", "女玩家"],
    views: 256000,
    likes: 18500,
  },
  {
    id: 3,
    title: "CSGO最搞笑的十个翻车瞬间：暴躁少女笑到肚子疼",
    slug: "csgo-zuigaoxiao-fanche-shunjian",
    category: "gaoxiao",
    categoryName: "搞笑集锦",
    excerpt: "收集了暴躁少女直播中最搞笑的十个翻车瞬间，从跳楼自杀到扔雷炸队友，每一个都让人笑出腹肌。",
    content: `CSGO是一个严肃的竞技游戏——直到你看了暴躁少女的翻车集锦。本期视频收录了少女直播中最令人捧腹的十个翻车名场面。

第一名毫无争议地属于"跳楼自杀"事件。在nuke的外场，少女本来想去下层绕后偷袭，结果在跳跃时角度没算好，直接从天台掉了下去，当场摔死。整个直播间沉默了整整三秒，然后被"哈哈哈哈"刷屏。少女自己也笑得趴在桌子上："我不玩了！这游戏针对我！"

第三名的"烟雾弹自杀"同样经典。少女想在dust2的中门封烟，结果烟雾弹砸在了门框上弹了回来，正好落在自己脚下。在一片白茫茫中，她被对面狙击手一枪带走。弹幕："自己给自己封了个坟"。

还有第五名的"手雷炸队友"。少女拉环准备丢雷，结果被敌人打了一下导致手滑，手雷掉在了队友脚下。四个队友全被炸飞，少女在语音里疯狂道歉："对不起对不起对不起！"队友们集体沉默后，队长淡定地说了一句："你是对面派来的吧。"

每一个翻车瞬间都让人笑得停不下来，但同时也让人感受到CSGO这款游戏的魅力——即使是失误，也能成为最欢乐的回忆。弹幕最高频的词是"快乐就完事了"。`,
    image: "https://readdy.ai/api/search-image?query=Funny%20gaming%20moment%20with%20female%20streamer%20laughing%20hysterically%20at%20desk%2C%20CSGO%20gameplay%20on%20monitor%2C%20colorful%20RGB%20gaming%20room%2C%20comedic%20expression%2C%20bright%20and%20lively%20atmosphere%2C%20streaming%20setup%20visible&width=800&height=450&seq=article-3&orientation=landscape",
    date: "2026-07-15",
    author: "暴躁少女",
    tags: ["翻车", "搞笑", "集锦", "直播"],
    views: 389000,
    likes: 32000,
  },
  {
    id: 4,
    title: "CSGO新手必看：从白银到AK的进阶之路（枪法篇）",
    slug: "csgo-xinshou-baiyin-dao-ak-qiangfa",
    category: "xinshou",
    categoryName: "新手教学",
    excerpt: "暴躁少女倾情奉献CSGO新手教学系列第一篇，从基础枪法讲起，包括压枪、预瞄和急停，助你快速脱离鱼塘局。",
    content: `很多新手玩家问暴躁少女："为什么我打了一千个小时还是白银？"答案很简单——你只是在玩，不是在练。本期教学，少女把自己从白银一路打到AK的心得毫无保留地分享出来。

首先是枪法基础。CSGO的枪法核心只有三个：压枪、预瞄和急停。压枪是最基础也最重要的技能，少女推荐新手从AK47开始练习。打开创意工坊的Recoil Master地图，每天花15分钟练习前15发子弹的弹道控制。少女强调："不要贪多，先把前15发练到80%命中率再说。"

预瞄是很多新手忽略的重点。少女在视频中展示了如何在地图的每个常见对枪位置提前将准星放在敌人可能出现的高度。她用一个简单的记忆方法：在所有地图中，敌人头部的高度大约在墙壁和门框的中间位置。养成准星始终放在"爆头线"上的习惯，你的反应时间会缩短至少200毫秒。

急停是区分高手和菜鸟的关键技能。少女用慢动作演示了急停的正确操作：按住A键移动时，松开A的瞬间轻点D键，在角色完全静止的刹那开枪。她建议新手在死亡竞赛模式中专门练习急停，不要在乎KDA，只关注每一次对枪是否做到了完美的急停。

最后，少女给出了一个简单但有效的训练计划：每天30分钟Recoil Master + 20分钟死亡竞赛练习急停 + 10分钟Aim Botz练习定位。坚持两周，你的枪法一定会有质的飞跃。`,
    image: "https://readdy.ai/api/search-image?query=CSGO%20training%20practice%20scene%20with%20gaming%20keyboard%20and%20mouse%2C%20monitor%20showing%20aim%20training%20map%2C%20clean%20minimal%20desk%20setup%2C%20professional%20gaming%20atmosphere%2C%20warm%20ambient%20lighting%2C%20educational%20content%20vibe&width=800&height=450&seq=article-4&orientation=landscape",
    date: "2026-07-12",
    author: "暴躁少女",
    tags: ["新手", "教程", "枪法", "进阶"],
    views: 520000,
    likes: 42000,
  },
  {
    id: 5,
    title: "CSGO 2026赛季最新更新解读：M4A1-S又被削了？",
    slug: "csgo-2026-saiji-gengxin-jiedu",
    category: "zixun",
    categoryName: "资讯速递",
    excerpt: "Valve发布了CSGO 2026年7月的最新平衡性更新，M4A1-S弹夹容量再遭削弱，AUG小幅加强，暴躁少女第一时间为你解读。",
    content: `7月22日，Valve悄然发布了CSGO的最新更新补丁。作为一个玩了五年CSGO的老玩家，暴躁少女第一时间上线测试，为大家带来最真实的体验分享。

本次更新的重点是武器平衡性调整。M4A1-S再次被削弱，弹夹容量从20发减少到18发。少女在测试后表示："Valve这是铁了心要让所有人都用M4A4啊。"不过她也指出，M4A1-S的精准度和消音器优势依然存在，在防守端仍然是一个非常可靠的选择，只是残局时的容错率进一步降低了。

AUG迎来了久违的加强，开镜状态下的射速略有提升。少女在视频中展示了AUG在dust2中门的新表现，认为这把武器在特定地图和位置可以成为很好的替代选择。"CT方现在有三把靠谱的步枪可以选了，战术多样性其实是增加了。"

除了武器调整，本次更新还修复了两个困扰玩家已久的bug：inferno香蕉道的贴图错误和nuke外场的穿墙点位。少女特别提到nuke的修复："那个点位被修了，喜欢在外场蹲人的玩家要重新找位置了。"

最后，少女给出了她的新版本武器推荐表：CT方首选M4A4（性价比最高），备选AUG（特定地图强势）；T方仍然是AK47的天下，但Galil在经济局的表现值得关注。想了解完整的更新内容和少女的详细分析，就点开视频吧！`,
    image: "https://readdy.ai/api/search-image?query=CSGO%20game%20update%20news%20with%20gaming%20monitor%20displaying%20patch%20notes%2C%20modern%20gaming%20desk%20setup%2C%20weapon%20skins%20visible%20on%20screen%2C%20clean%20professional%20gaming%20environment%2C%20news%20style%20photography&width=800&height=450&seq=article-5&orientation=landscape",
    date: "2026-07-22",
    author: "暴躁少女",
    tags: ["更新", "平衡性", "M4A1-S", "版本"],
    views: 198000,
    likes: 13500,
  },
  {
    id: 6,
    title: "暴躁少女VS水友赛：被粉丝暴打是一种什么体验",
    slug: "baozhao-shaonv-shuiyou-sai",
    category: "gaoxiao",
    categoryName: "搞笑集锦",
    excerpt: "暴躁少女举办了一场水友赛，本以为可以轻松虐菜，结果被隐藏大神粉丝打得满地找牙。从自信满满到怀疑人生的全过程。",
    content: `"水友赛嘛，就是娱乐娱乐。"——暴躁少女在比赛开始前如是说。两个小时后，她瘫在椅子上，眼神空洞地看着结算画面："我的粉丝里到底藏了多少职业选手？"

事情的起因是少女在B站粉丝突破50万后，决定举办一场水友赛来庆祝。规则很简单：少女带四个粉丝组队，对战另外五个粉丝。她信誓旦旦地说："我带你们飞，保证三局全胜。"

第一局，少女队在dust2的CT方。开局不到30秒，少女在A大道被对面某位叫"路人甲"的粉丝用沙鹰一枪爆头。少女愣了愣："运气，绝对是运气。"然而"路人甲"接下来用沙鹰连杀了少女三次，每次都是精准的爆头。弹幕疯狂刷屏："这哪是水友赛，这是处刑现场。"

第二局换到了mirage，少女选择了T方，准备用AK证明自己。结果对面一位ID叫"菜鸟求带"的粉丝，用AWP在中路连狙三人，其中包括少女。少女崩溃大喊："你的ID是骗人的吧！"

最搞笑的是第三局，少女终于拿到了一个击杀，激动得从椅子上跳了起来。然而队友提醒她："那是你自己扔的燃烧弹烧死的队友……"少女低头一看屏幕，沉默了三秒钟："今天的直播就到这里。"

整场水友赛虽然输了，但节目效果拉满，弹幕人数创了少女直播间的历史新高。粉丝们纷纷表示："求求你每周都办水友赛！"`,
    image: "https://readdy.ai/api/search-image?query=Female%20streamer%20with%20shocked%20exaggerated%20expression%20during%20gaming%20session%2C%20colorful%20streaming%20setup%20with%20chat%20visible%20on%20second%20monitor%2C%20fun%20and%20energetic%20atmosphere%2C%20bright%20RGB%20lighting%2C%20comedic%20gaming%20moment&width=800&height=450&seq=article-6&orientation=landscape",
    date: "2026-07-10",
    author: "暴躁少女",
    tags: ["水友赛", "粉丝", "搞笑", "直播"],
    views: 445000,
    likes: 38500,
  },
  {
    id: 7,
    title: "暴躁少女CSGO道具教学：十个你必须掌握的实用烟雾弹",
    slug: "csgo-daoju-jiaoxue-shiyong-yanmu",
    category: "xinshou",
    categoryName: "新手教学",
    excerpt: "道具是CSGO高手与菜鸟的分水岭。暴躁少女精选十个最实用的烟雾弹点位，从dust2到inferno，覆盖所有排位常用地图。",
    content: `如果说枪法是CSGO的基础，那道具有用就是进阶的阶梯。暴躁少女在这期教学视频中，精选了十个新手最容易掌握、实战价值最高的烟雾弹点位。

第一个推荐的是dust2的中门烟。这是全CSGO最经典的烟雾弹之一，从T家出生点直接投向中门，可以完全封住CT从中门观察Xbox的视野。少女用慢动作详细展示了站位、准星参照物和投掷方式。"这个烟只要练三遍就能学会，但它的战略价值是无限的。"

第三个是inferno的CT烟。从T方香蕉道投掷，可以封住CT方在B点的守点视野。少女特别强调了站位的重要性："你的背必须紧贴这个墙壁，准星对准那个窗框的右上角。差一点点烟就会偏，导致漏缝被狙击手穿透。"

第五个是mirage的VIP烟。少女坦言这是十个烟中最难的一个，但一旦掌握，在进攻A点时几乎是必用的。"先跑到这个垃圾桶旁边，准星对准对面建筑顶部的天线，跳跃投掷。练习十次左右就能有80%以上的成功率。"

在教学的最后，少女分享了她的道具练习方法：打开创意工坊的Yprac地图，每次排队等待的时候练习3-5个烟雾弹。"排队时间加起来每天至少有20分钟，一年下来就是120个小时的道具练习，足够你超越99%的玩家了。"

这期视频被粉丝称为"最良心的CSGO教学之一"，收藏量破了少女频道的纪录。不少粉丝在评论区晒出自己练习成功后的截图，少女也一一回复点赞。`,
    image: "https://readdy.ai/api/search-image?query=CSGO%20map%20training%20with%20smoke%20grenade%20trajectories%20displayed%20on%20screen%2C%20gaming%20monitor%20showing%20tactical%20view%2C%20keyboard%20with%20highlighted%20keys%2C%20educational%20gaming%20content%2C%20clean%20desk%20setup%2C%20warm%20lighting&width=800&height=450&seq=article-7&orientation=landscape",
    date: "2026-07-08",
    author: "暴躁少女",
    tags: ["道具", "烟雾弹", "教程", "地图"],
    views: 612000,
    likes: 51000,
  },
  {
    id: 8,
    title: "暴躁少女深夜排位：遇到四个小学生队友的绝望三小时",
    slug: "baozhao-shaonv-xiaoxuesheng-duiyou",
    category: "baozhao",
    categoryName: "暴躁时刻",
    excerpt: "深夜排位本以为是安静上分的好时机，结果连续排到小学生队友。从忍耐到崩溃，暴躁少女的情绪曲线堪比过山车。",
    content: `晚上十一点，暴躁少女戴上耳机，泡了一杯咖啡，准备在夜深人静的时候好好上一波分。她的原话是："深夜的CSGO才是真正的CSGO，小学生都睡了。"——事实证明，这句话错得离谱。

第一局还算正常，队友虽然不太说话但配合得还不错，少女轻松拿下。但从第二局开始，噩梦降临了。

"姐姐姐姐，你是什么段位的？"语音里传来了一个稚嫩的童声。少女的表情瞬间凝固。紧接着又有两个小朋友加入了语音："我也会玩CSGO！""我AK很厉害的！"——后来少女发现，这个"AK很厉害"的小朋友全场KDA是0.2。

最崩溃的一局发生在mirage。少女在A点下包后指挥队友守点，结果四个小学生队友一起挤在了宫殿里，美其名曰"埋伏"。少女大喊："你们四个人挤一个角落，一颗手雷不就全没了吗？"话音刚落，对面一颗燃烧弹丢进来，四个队友像受惊的小鸟一样四散而逃，全部被击杀。

少女在最后十分钟已经完全放弃指挥了，只是安静地打自己的，偶尔叹口气。弹幕反而更欢乐了，纷纷安慰她："输了比赛赢了快乐"、"建议改名：暴躁少女带娃记"、"这期视频的素材够做三个视频了"。

最终结算：打了三个小时，赢了两局，输了六局，段位掉了一级。少女对着镜头露出一个疲惫的微笑："我以后再也不深夜打CSGO了……至少周末不打了。"`,
    image: "https://readdy.ai/api/search-image?query=Tired%20female%20gamer%20with%20exhausted%20expression%20at%20gaming%20desk%20late%20at%20night%2C%20dim%20room%20lighting%20with%20monitor%20glow%2C%20coffee%20cup%20on%20desk%2C%20CSGO%20defeat%20screen%20visible%2C%20atmospheric%20night%20gaming%20session%2C%20warm%20dark%20tones&width=800&height=450&seq=article-8&orientation=landscape",
    date: "2026-07-05",
    author: "暴躁少女",
    tags: ["深夜", "小学生", "排位", "崩溃"],
    views: 356000,
    likes: 28500,
  },
  {
    id: 9,
    title: "CSGO职业比赛精彩复盘：2026 Major总决赛巅峰对决",
    slug: "csgo-2026-major-zongjuesai-fupan",
    category: "jingcai",
    categoryName: "精彩操作",
    excerpt: "暴躁少女带你复盘2026 CSGO Major总决赛的五个关键回合，从战术布置到选手操作，深度解析顶级战队的对决。",
    content: `2026年CSGO Major总决赛刚刚落下帷幕，两支世界顶级战队为我们奉献了一场载入史册的BO3决赛。暴躁少女熬夜看完比赛后，第一时间做了这期复盘视频。

第一个关键回合发生在dust2的第七局。T方在落后两分的情况下，选择了一套非常规的B点快攻战术。少女逐帧分析了这个战术的布置：三颗烟雾弹同时封住了B门、窗口和car位，两颗闪光弹完美覆盖了整个B点。"这不是临时起意的rush，而是精心设计的战术。从烟雾弹的落点来看，他们在训练中至少练习了这个战术上百次。"

第三个关键回合是整场比赛的转折点。在mirage的第十四局，CT方的狙击手上演了一波一打三的残局逆转。少女用0.5倍速慢动作回放了每一个击杀："注意看他的身位控制，始终只暴露给一个敌人。这种残局的走位选择，需要上千小时的比赛经验才能做到如此精准。"

决赛的最后一局，少女称之为"教科书级别的心态博弈"。T方在ECO局选择了全甲手枪rush B，这是一个极度冒险的选择。少女分析道："在Major决赛的赛点局选择ECO rush，需要整支队伍有钢铁般的心理素质。这不仅仅是FPS技术的比拼，更是心理战。"

视频最后，少女感慨道："CSGO的魅力就在于，即使你看了十年比赛，依然能被选手的创意和勇气震撼。"这期复盘视频让很多不太关注职业比赛的粉丝也开始对赛事产生了兴趣。`,
    image: "https://readdy.ai/api/search-image?query=Professional%20CSGO%20esports%20tournament%20stage%20with%20large%20screens%20and%20audience%2C%20intense%20competition%20atmosphere%2C%20players%20in%20gaming%20chairs%2C%20stadium%20lighting%2C%20grand%20event%20photography%2C%20dramatic%20esports%20scene&width=800&height=450&seq=article-9&orientation=landscape",
    date: "2026-07-03",
    author: "暴躁少女",
    tags: ["Major", "职业比赛", "复盘", "总决赛"],
    views: 290000,
    likes: 22000,
  },
  {
    id: 10,
    title: "暴躁少女CSGO灵敏度设置分享：职业选手都这样调",
    slug: "csgo-lingmindu-shezhi-fenxiang",
    category: "xinshou",
    categoryName: "新手教学",
    excerpt: "灵敏度是CSGO中最个人化但最重要的设置之一。暴躁少女分享自己的灵敏度配置思路，并整理了多位职业选手的设置供参考。",
    content: `"你的灵敏度是多少？"这是CSGO社区中最常被问到的问题之一。暴躁少女在这期视频中不仅分享了自己的设置，还深入讲解了选择灵敏度的思路和方法。

少女的当前设置是：DPI 800，游戏内灵敏度 0.9，eDPI 720。她解释了自己选择这个灵敏度的心路历程："我最开始用的是1600 DPI + 2.5灵敏度，eDPI高达4000。那时候我还奇怪为什么瞄不准人——因为你手腕抖一毫米，准星就能飞出去半张地图。"

她推荐新手从一个中等偏低的eDPI开始：大约在600到1000之间。"这个范围内的灵敏度既可以保证足够的转身速度，又不会牺牲精准度。"少女在视频中演示了如何测试自己的灵敏度是否合适：在训练地图中，尝试用一次扫射转移击杀两个静止目标，如果经常拉过头就降低灵敏度，如果拉不到就提高。

视频中少女还整理了多位职业选手的灵敏度设置作为参考：s1mple使用400 DPI + 3.09灵敏度（eDPI 1236），ZywOo使用400 DPI + 2.00灵敏度（eDPI 800），NiKo使用400 DPI + 1.52灵敏度（eDPI 608）。"看到了吗？即使是世界最顶尖的选手，灵敏度也各不相同。关键不是模仿别人，而是找到最适合自己的。"

最后少女提了一个很实用的建议：每三个月重新测试一次自己的灵敏度需求，因为随着水平提高，你的最佳灵敏度可能会发生变化。不要害怕调整，但要一次只调一点点。`,
    image: "https://readdy.ai/api/search-image?query=Gaming%20mouse%20and%20large%20mousepad%20on%20clean%20desk%20with%20CSGO%20settings%20menu%20displayed%20on%20monitor%2C%20professional%20gaming%20setup%2C%20warm%20ambient%20light%2C%20detailed%20close-up%20of%20gaming%20peripherals%2C%20technical%20content%20style&width=800&height=450&seq=article-10&orientation=landscape",
    date: "2026-06-30",
    author: "暴躁少女",
    tags: ["灵敏度", "设置", "职业选手", "配置"],
    views: 478000,
    likes: 39500,
  },
  {
    id: 11,
    title: "暴躁少女试玩CSGO新地图：这设计是认真的吗？",
    slug: "csgo-xinditu-shiwan-pingce",
    category: "baozhao",
    categoryName: "暴躁时刻",
    excerpt: "CSGO社区工坊新上架了一张热门地图，暴躁少女第一时间试玩。从好奇到困惑再到暴躁，一张地图引发的情绪过山车。",
    content: `社区工坊是CSGO创意的源泉，但并不是每张地图都值得被收录。暴躁少女这期视频试玩了一张最近在社区中热度很高的新地图，而她的评价可以用四个字来概括："什么鬼啊！"

这张名为"de_factory"的地图设定在一个废弃工厂中。少女刚进入地图，就被复杂的路线绕晕了。"我从A点走到B点花了40秒，而且中间经过了六个岔路口。这是CSGO地图还是迷宫？"

更让少女抓狂的是地图的视觉设计。工厂内部的色调偏暗，CT方的角色模型几乎和背景融为一体。"这哪是竞技地图，这是捉迷藏地图吧？我在B点守了三分钟，一个T都没看见，后来看回放才发现有两个T从我面前走过去了！"

地图的炸弹点位设计也颇具争议。A点的下包区域在一条狭窄的传送带上，T方下包时完全暴露在三个方向的火力下。少女尝试下包失败后暴躁吐槽："设计师是觉得我下包的时候应该表演杂技吗？"

但少女也肯定了地图的一些创意元素，比如可以开关的工厂大门和可破坏的玻璃窗。"这些机制如果放在一张设计更合理的地图上，其实会非常有趣。只是目前这个版本，我只能给两分——一分给创意，一分给勇气。"

视频发布后，地图的制作者在评论区出现了，表示会认真考虑少女的建议进行修改。少女也大方地回复鼓励了制作者，展现了暴躁外表下的暖心一面。`,
    image: "https://readdy.ai/api/search-image?query=CSGO%20custom%20map%20with%20industrial%20factory%20setting%20displayed%20on%20gaming%20monitor%2C%20female%20gamer%20with%20confused%20expression%2C%20dark%20atmospheric%20industrial%20design%20on%20screen%2C%20gaming%20setup%20in%20background%2C%20map%20review%20content&width=800&height=450&seq=article-11&orientation=landscape",
    date: "2026-06-28",
    author: "暴躁少女",
    tags: ["新地图", "工坊", "试玩", "评测"],
    views: 167000,
    likes: 12500,
  },
  {
    id: 12,
    title: "CSGO 2026年下半年赛事日历：这些比赛你绝对不能错过",
    slug: "csgo-2026-xia-bannian-saishi-rili",
    category: "zixun",
    categoryName: "资讯速递",
    excerpt: "暴躁少女整理了2026年下半年最重要的CSGO赛事安排，从ESL到Blast，从线下赛到线上联赛，一篇搞定你的观赛计划。",
    content: `2026年下半年的CSGO赛事安排已经基本确定，暴躁少女为大家整理了一份最全的观赛指南。不管你是资深赛事迷还是刚入坑的新观众，这份日历都值得收藏。

七月底即将开打的ESL Pro League Season 22是本季度的重头戏。24支顶级战队将争夺总计85万美元的奖金池。少女特别标注了几支值得关注的队伍："G2在新阵容磨合后状态火热，NAVI的年轻选手成长速度惊人，而FaZe的老将们依然宝刀不老。"

八月的IEM Cologne是每年最受瞩目的线下赛事之一。少女回忆道："去年的科隆站，现场观众的呐喊声通过直播都能让人起鸡皮疙瘩。今年据说门票开售三分钟就售罄了，氛围一定会更加炸裂。"

九月的Blast Premier秋季赛采用了全新的赛制，增加了更多的小组循环赛。"新赛制意味着更多的比赛场次，也意味着更多的爆冷可能。对于观众来说是好事，对于强队来说就不一定了。"

少女还特别提醒大家关注十月的亚洲区Minor预选赛。"中国队伍在最近两年的进步非常明显，这次Minor是冲击年底Major的重要机会。希望大家多多支持中国CSGO！"

视频最后，少女附上了一个可下载的赛事日历文件，方便粉丝导入手机日历。评论区里粉丝纷纷表示："终于有人整理赛事日历了"、"收藏了，下半年的周末都安排上了"。`,
    image: "https://readdy.ai/api/search-image?query=CSGO%20esports%20tournament%20schedule%20calendar%20display%20on%20monitor%20with%20team%20logos%2C%20gaming%20news%20content%2C%20modern%20clean%20desk%20setup%2C%20professional%20esports%20journalism%20vibe%2C%20bright%20and%20informative%20visual%20style&width=800&height=450&seq=article-12&orientation=landscape",
    date: "2026-06-25",
    author: "暴躁少女",
    tags: ["赛事", "日历", "下半年", "电竞"],
    views: 210000,
    likes: 16000,
  },
];

export const faqData = [
  {
    question: "B站暴躁少女的CSGO视频在哪里可以看？",
    answer: "暴躁少女的CSGO视频主要在B站（哔哩哔哩）发布，您可以在B站搜索「暴躁少女」或「暴躁少女CSGO」找到她的频道。她的视频内容涵盖CSGO精彩操作、搞笑集锦、新手教学和赛事资讯等。",
  },
  {
    question: "暴躁少女的CSGO段位是什么？",
    answer: "根据暴躁少女在视频中透露的信息，她目前的CSGO段位在菊花（DMG）到小老鹰（LE）之间波动。她经常在视频中分享自己的排位经历，包括连胜和连跪的真实记录。",
  },
  {
    question: "新手看暴躁少女的哪个系列视频最合适？",
    answer: "推荐新手从「新手教学」系列开始看起，其中《从白银到AK的进阶之路》和《道具教学：十个实用烟雾弹》是入门必看的两期视频。这些教程深入浅出，即使是完全没接触过CSGO的玩家也能轻松跟上。",
  },
  {
    question: "暴躁少女的直播时间是什么时候？",
    answer: "暴躁少女通常在每周二、四、六的晚上8点到11点进行直播，具体时间可能会根据实际情况调整。建议关注她的B站动态，直播开始前都会提前通知。",
  },
  {
    question: "本站内容是否经过暴躁少女本人授权？",
    answer: "本站是暴躁少女CSGO视频的粉丝专题站，所有内容均来源于公开信息，旨在为广大CSGO爱好者提供内容聚合和观看指南服务。如需联系暴躁少女本人，请通过B站私信。",
  },
  {
    question: "如何在CSGO中快速提升枪法？",
    answer: "暴躁少女推荐的方法是：每天练习30分钟Recoil Master地图（压枪训练）、20分钟死亡竞赛（急停训练）、10分钟Aim Botz（定位训练）。坚持两周就能看到明显进步。关键不在于时间多长，而在于每天坚持。",
  },
  {
    question: "暴躁少女用的什么外设？",
    answer: "暴躁少女在视频中展示的外设包括：显示器为ZOWIE XL2546K（240Hz），鼠标为Logitech G Pro X Superlight，键盘为Wooting 60HE，耳机为HyperX Cloud II。不过她强调外设不是最重要的，找到适合自己的设置才是关键。",
  },
];

export const aboutData = {
  brandName: "B站暴躁少女CSGO视频专题站",
  brandIntro: "B站暴躁少女CSGO视频专题站是一个专注于CSGO游戏视频内容的聚合平台。我们围绕B站知名UP主「暴躁少女」的CSGO视频内容，为玩家提供视频资讯、精彩集锦、观看指南和社区互动。无论你是想找最新视频、学习CSGO技巧，还是寻找志同道合的游戏伙伴，这里都是你的最佳选择。",
  brandStory: "「暴躁少女」是B站上一位以真实、幽默风格著称的CSGO内容创作者。她的视频以坦诚直率的个性、精湛的游戏技术和密集的笑点赢得了大量粉丝的喜爱。从最初的个人兴趣分享，到如今拥有数十万粉丝的知名UP主，暴躁少女始终坚持做真实的自己——赢了会开心得手舞足蹈，输了也会毫不掩饰地暴躁吐槽。正是这种不做作的真性情，让她在众多游戏主播中脱颖而出。我们创建这个专题站，就是希望让更多CSGO爱好者能够方便地找到她的优质内容，同时也为玩家们搭建一个交流和分享的平台。",
  reputation: [
    { label: "视频总播放量", value: "超过 5,000 万次" },
    { label: "B站粉丝数", value: "50 万+" },
    { label: "视频总数", value: "300+ 期" },
    { label: "粉丝好评率", value: "98.5%" },
  ],
  contact: {
    email: "contact@baozhaocsgo.cn",
    bilibili: "https://space.bilibili.com/暴躁少女",
    weibo: "暴躁少女CSGO",
  },
  siteInfo: "本站为粉丝自发创建的专题资讯站，与B站官方及暴躁少女本人无直接关联。所有视频内容版权归原作者所有。如涉及侵权或其他问题，请通过邮件联系我们。",
};